import styles from "./platform-opportunities.module.scss";
import animations from "@components/shared/animation/animations.module.scss";
import SharedAnimation from "@components/shared/animation";
import Image from "next/image";
import { useEffect } from "react";

export interface IPlatformOpportunities {
  title: string;
  imageUrl: string;
  content: string[];
}

type PlatformOpportunitiesProps = {
  platform: IPlatformOpportunities;
};

const PlatformOpportunities = ({ platform }: PlatformOpportunitiesProps): JSX.Element => {
  return (
    <>
      <SharedAnimation
        render={(ref) => (
          <div
            ref={ref}
            className={`${styles.containerDifferent} ${animations.scroll__animation}`}
          >
            <section className={`${styles.section}`}>
              <div className={styles.platformOpportunities}>
                <div className={styles.platformOpportunities__info}>
                  <h2 className={styles.platformOpportunities__info__title}>
                    {platform.title}
                  </h2>
                  <div
                    className={styles.platformOpportunities__info__subtitles}
                  >
                    {platform.content.map((item: string, index: number) => (
                      <div
                        key={index}
                        className={
                          styles.platformOpportunities__info__subtitles__wrapper
                        }
                      >
                        <div
                          className={
                            styles.platformOpportunities__info__subtitles__wrapper__dot
                          }
                        ></div>
                        <div
                          className={
                            styles.platformOpportunities__info__subtitles__wrapper__text
                          }
                        >
                          {item}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className={styles.platformOpportunities__image}>
                  <Image
                    src={platform.imageUrl}
                    alt={platform.title}
                    layout={"fill"}
                    objectFit={"contain"}
                    loading="eager"
                  />
                </div>
              </div>
            </section>
          </div>
        )}
      />
    </>
  );
};

export default PlatformOpportunities;
